/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { IStackProps, Stack } from '@fluentui/react/lib/Stack';
import * as React from 'react';
import { getStylist } from 'src/core/themes/luisStylist';

const { styleComponent } = getStylist('TileFooter');

const Footer = styleComponent<IStackProps>(Stack)('Footer', theme => ({
    height: theme.tileHeight,
    borderTop: theme.tileBorderTop,
    marginTop: theme.tileMarginTop
}));

/**
 * Represents the tile footer, which is fixed at the end of the tile
 * and usually contains action buttons.
 *
 * @param props Contains the children projected in the footer component.
 */
export const TileFooter: React.FunctionComponent<{ children?: React.ReactNode }> = props => (
    <Footer horizontal verticalAlign="center" horizontalAlign="center">
        {props.children}
    </Footer>
);
